import React, { useEffect } from 'react';
import { ChatModal } from './ChatModal';
import { useChat } from '../contexts/ChatContext';
import style from "../styles/chat.module.sass"
import { ChatProps, WebSocketMessage } from '../interfaces/interfaces';
import { ConfigProvider, theme as antdTheme } from "antd"


export function Chat(props: ChatProps) {
    const { openChatModal, setOpenChatModal, setUser, rooms, setRooms, setMode, setToken, setChatSocket, chatSocket: socket, setTheme, unreadList, setUnreadList, unread, setUnread } = useChat();
    const { token, user, mode, className, icon, theme } = props;

    // console.log('mode', mode)
    const endpoint = process.env.REACT_APP_CURIOBITES_WS_HOST + `/ws/api/ChatRooms/${mode}/${token}/`;

    useEffect(() => {
        setMode(mode)
        setToken(token)
        theme && setTheme(theme)
    }, []);


    useEffect(() => {
        if (!socket) {
            const newSocket = new WebSocket(endpoint);
            setChatSocket(newSocket)
        } else {

            socket.onopen = (event) => {
                console.log('WebSocket connection opened', event);

                if (mode === "Integrate") {
                    const data = {
                        event_type: "INTEGRATION_AUTHENTICATE",
                        user: user
                    }

                    socket.send(JSON.stringify(data))
                }

            };

            socket.onmessage = (event) => {
                // console.log("WebSocket message received:", event);

                const data: WebSocketMessage = JSON.parse(event.data);
                // console.log(data.event_type);
                if (data.event_type === "rooms") {
                    setRooms(data.rooms || []);
                }
                if (data.event_type === "notifications") {
                    setUnreadList(data.unread_list || []);
                    setUnread(data.unread || 0);
                    setRooms(data.rooms || []);
                }
                if (data.event_type === "INTEGRATION_AUTHENTICATE") {
                    // setUser
                    console.log('data', data)
                    setToken(data.token.access)

                    //  reconnect the socket here after get token access 
                    socket.close()
                    const endpoint = process.env.REACT_APP_CURIOBITES_WS_HOST + `/ws/api/ChatRooms/${mode}/${data.token.access}/`;
                    const newSocket = new WebSocket(endpoint);
                    setChatSocket(newSocket)

                }

                if (data.event_type === "OPEN_ROOM") {
                    // setRooms(prev => [...prev, data.room])
                    setOpenChatModal(true)
                }
            };

            socket.onclose = (event) => {
                console.log('WebSocket connection closed', event);
            };

            socket.onclose = (event) => {
                console.log('WebSocket Error', event);
            };

        }

    }, [endpoint, socket]);

    // console.log('rooms', socket)

    useEffect(() => {
        if (user) {
            setUser(user)
        }
    }, [user]);

    return (
        <ConfigProvider
            theme={{ algorithm: theme === "dark" ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm }}
        >

            <div className={`${style.curiobites_chat} ${className ? className : ""} curiobites-chat`} >
                <ChatModal
                    unreadList={unreadList}
                    open={openChatModal}
                    close={() => setOpenChatModal(false)}
                    rooms={rooms}
                    {...props}

                />
                <div className={style.chat} onClick={() => setOpenChatModal(true)}>
                    {unread > 0 &&
                        <div className={style.notif_count}>
                            {unread}
                        </div>
                    }
                    {icon ? icon : <i className={`fas fa-comment-alt ${style.chat_icon}`}></i>}

                </div>
            </div>
        </ConfigProvider >
    );
}


export const CreateRoom = async (users: any, socket: any) => {

    const data = {
        event_type: "OPEN_ROOM",
        users: users
    }

    console.log('create room------->', users, socket)
    socket.send(JSON.stringify(data))

}